import { ComponentType, ReactNode } from "react";

export interface INotificationCandidate {
  id: string;
  priority: number;
  isActive: boolean;
  delayMs?: number;
  render: () => ReactNode;
}

export interface INotificationResolverProps {
  priority: number;
}

export interface INotificationModule {
  id: string;
  Resolver: ComponentType<INotificationResolverProps>;
}

export interface INotificationRuntimeContext {
  activeCandidate: INotificationCandidate | null;
  removeCandidate: (id: string) => void;
  upsertCandidate: (candidate: INotificationCandidate) => void;
}

export const defineNotificationModule = (module: INotificationModule): INotificationModule => module;
